import { sectionAnchors } from '../../../config/routes'

// OMR + handwriting coverage, ported verbatim from the prototype's
// .reads-grid markup.
export const WhatItReadsSection = () => {
  return (
    <section id={sectionAnchors.whatItReads.slice(1)}>
      <div className="wrap">
        <div className="sec-head">
          <span className="eyebrow">What it reads</span>
          <h2>Any sheet. Any layout. No rigid template.</h2>
        </div>
        <div className="reads-grid">
          <div className="read-card">
            <h3>Bubble sheets (OMR)</h3>
            <p>Shaded-circle forms are read like a scantron — but with your phone, not a machine.</p>
            <div className="chips">
              <span className="chip">Marked forms</span>
              <span className="chip">Shaded circles</span>
              <span className="chip">No special paper</span>
            </div>
          </div>
          <div className="read-card">
            <h3>Handwritten answers</h3>
            <p>Any layout, no rigid template — QuickScore reads what students actually wrote.</p>
            <div className="chips">
              <span className="chip">Multiple choice</span>
              <span className="chip">True / False</span>
              <span className="chip">Identification</span>
              <span className="chip">Enumeration</span>
              <span className="chip">Fill-in-the-blanks</span>
              <span className="chip">Open response</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
